import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "corporate-view" }
const _hoisted_2 = { class: "row g-0 red-color justify-content-center text-white mt-4 pt-5 pb-5" }
const _hoisted_3 = { class: "col-8 text-left" }
const _hoisted_4 = { style: {"font-size":"1.15rem"} }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "bg-black text-center text-white mt-4 pb-2 pt-3 fs-3" }
const _hoisted_10 = { class: "mb-0 pb-0 agency-signature-main" }
const _hoisted_11 = { class: "mb-0 pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.content1), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.content2), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.content3), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.content4), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.signatureMain), 1),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.websiteUrl), 1)
    ])
  ]))
}